// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgAppLogoShortMonochrome = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={104} height={88} viewBox="0 0 104 88" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_1541_25189)" fill="#fff">
      <path d="M64 88h.131a12 12 0 0 0 9.472-4.632l9.245-11.885a12 12 0 0 0 .025-14.705L73 44h31L73.603 4.663A12 12 0 0 0 64.108 0H64L51.46 16.124 73 44H42l9.873 12.778a12 12 0 0 1-.025 14.705l-.347.447L64 88Z" />
      <path d="M64.125 0H33.869a12 12 0 0 0-9.472 4.633L4.912 29.685a23.316 23.316 0 0 0 0 28.63l19.485 25.052A12 12 0 0 0 33.869 88H64.13l-.045-.026a12 12 0 0 1-8.688-4.607L35.91 58.315a23.317 23.317 0 0 1 0-28.63L55.397 4.633A12 12 0 0 1 64.022.03c.037-.003.103.012.103-.03Z" />
    </g>
    <defs>
      <clipPath id="clip0_1541_25189">
        <path fill="#fff" d="M0 0h104v88H0z" />
      </clipPath>
    </defs>
  </svg>
))
SvgAppLogoShortMonochrome.displayName = 'SvgAppLogoShortMonochrome'
const Memo = memo(SvgAppLogoShortMonochrome)
export { Memo as SvgAppLogoShortMonochrome }
